import axios from "axios";
import { SERVER_URL } from "../../../../config/env";
import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

const teacherService = {
  /**
   * =========================================================
   * ✅ TEACHER PRESENCE
   * =========================================================
   */
  async getTeacherPresence() {
    const res = await axios.get(SERVER_URL + "bsz/teachers", {
      headers: authHeader(),
    });

    return res.data;
  },

  async getTeachers() {
    // const res = await axios.get(SERVER_URL + "bsz/myteachers", {
    //   headers: authHeader(),
    // });

    // return res.data;
    return [];
  },
};

export default teacherService;
